// Helper: tool's execute() gọi để navigate + await form submit.
// Trả Promise resolve khi form gọi resolveCurrent, reject khi rejectCurrent.

import type { PendingUiActionStore } from "./pending-store";
import { encodePrefill } from "./query-codec";
import type { ExecuteViaFormOptions } from "./types";

/// Factory: takes navigate fn (từ Solid useNavigate) + store, returns helper fn.
/// Inject vào tool definitions của app (vd buildBookingTools).
export function createExecuteViaForm(
  navigate: (path: string) => void,
  store: PendingUiActionStore,
): (opts: ExecuteViaFormOptions) => Promise<unknown> {
  return (opts) =>
    new Promise<unknown>((resolve, reject) => {
      // Replace prior (auto-reject) + set new pending.
      store.replace({
        toolName: opts.toolName,
        args: opts.args,
        resolve,
        reject,
      });

      // Resolve `:id` placeholder trong route từ args.id (nếu có).
      const args = opts.args as { id?: string; ticket_id?: string } | undefined;
      const finalRoute = opts.route.includes(":id")
        ? opts.route.replace(":id", String(args?.id ?? args?.ticket_id ?? ""))
        : opts.route;

      const params = new URLSearchParams({
        intent: opts.intent,
        prefill: encodePrefill(opts.args),
      });

      navigate(`${finalRoute}?${params.toString()}`);
    });
}
